import React, { useState } from "react";
import Header from "../components/inc/Header";
import LeftSidebar from "../components/inc/LeftSidebar";
import RightSideBar from "../components/inc/RightSideBar";
import { useDispatch, useSelector } from "react-redux";
import { useQuery } from "react-query";
import { serverUrl } from "../nestserver";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { loginUser, selectUser } from "../redux/slices/auth.slice";
import { message } from "antd";
import SchoolSplash from "../components/SchoolSplash";

const SplashScreen = () => {
  return (
    <div style={{ display: "flex", width: "100vw", height: "100vh" }}>
      <div style={{ margin: "auto", fontSize: "1.5rem" }}>Loading...</div>
    </div>
  );
};

const DashboardLayout = ({ children }) => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [rightSidebarCollapsed, setRightSidebarCollapsed] = useState(
    () => window.localStorage.getItem("sidebar-collapsed") === "true",
  );

  const toggleRightSidebar = () => {
    setRightSidebarCollapsed((prev) => {
      const next = !prev;
      window.localStorage.setItem("sidebar-collapsed", String(next));
      return next;
    });
  };

  const autoLogin = () => {
    return axios({
      method: "post",
      url: serverUrl + "/auth/me",
      data: {},
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
  };

  const userDetails = useQuery("user", autoLogin, {
    onSuccess(data) {
      dispatch(loginUser(data?.data));
    },
    onError(data) {
      if (window.localStorage.getItem("jwt-token")) {
        message.error("Session Expired !");
      }
      dispatch(loginUser(null));
      navigate("/auth/login");
    },
    retry: 1,
  });

  if (user === undefined) {
    return <SplashScreen />;
  }

  return (
    <div
      style={{ backgroundColor: "#E5E5E5" }}
      className="flex flex-col h-screen overflow-y-scroll"
    >
      <SchoolSplash />
      <div className="h-16 w-full bg-left">
        <Header />
      </div>

      <div className="h-0 flex-grow flex overflow-y-hidden w-full">
        <div className="w-28 bg-white relative" style={{ zIndex: 1000 }}>
          <LeftSidebar />
        </div>

        <div className="w-0 min-w-0 flex-grow h-full overflow-auto z-50">
          {children}
        </div>

        <div
          className={`h-full bg-white rounded-2xl mt-8 mr-10 overflow-y-auto overflow-x-hidden transition-all duration-300 ease-in-out ${
            rightSidebarCollapsed ? "w-14" : "w-80"
          }`}
          onTransitionEnd={(e) => {
            if (e.propertyName === "width") {
              window.dispatchEvent(new Event("resize"));
            }
          }}
        >
          <RightSideBar
            collapsed={rightSidebarCollapsed}
            onToggle={toggleRightSidebar}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
